<template>
    <b-standard-card
        :title="translations.title[lang]"
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        :loading="loading"
        class="mt-5"
        height="auto"
        :error-message="errorMessage"
        @submit="
            updateSmsRedemption({
                type: 'sms_redemption',
                item: { sms_coupon_claim_message: sms_coupon_claim_message }
            })
        "
    >
        <span v-html="translations.smsRedemptionInfo[lang]"></span>
        <div
            class="pa-1 pb-0 text-center text-subtitle-2 text--secondary font-weight-light font-italic"
        >
            *<span class="">{{
                translations.dynamicRewardSmsVariable[lang]
            }}</span>
        </div>
        <b-textarea
            :label="translations.message[lang]"
            v-model="sms_coupon_claim_message"
            isSms
        ></b-textarea>
    </b-standard-card>
</template>

<script>
import translations from "@/utils/translations/loyaltyPanel/businessProfile/smsRedemption";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
    name: "SmsRedemption",
    mixins: [translations],
    data() {
        return {
            sms_coupon_claim_message: ""
        };
    },

    computed: {
        lang() {
            return this.$route.params.lang;
        },
        loading() {
            return this.$store.state.loyaltyPanel.businessProfile.loading
                .sms_redemption;
        },

        errorMessage() {
            return this.$store.state.loyaltyPanel.businessProfile.errorMessage
                .sms_redemption;
        },
        resetSuccess() {
            return this.$store.state.loyaltyPanel.businessProfile.resetSuccess
                .sms_redemption;
        }
    },
    methods: {
        ...mapActions("loyaltyPanel/businessProfile", [
            "updateSmsRedemption"
        ])
    },

    watch: {
        ["$store.state.loyaltyPanel.businessProfile.businessProfileData"]: {
            handler(val) {
                this.sms_coupon_claim_message =
                    val.sms_coupon_claim_message || "";
            }
        }
    }
};
</script>
